const PurchasersLimitIcon = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        {...props}
    >
        <g clipPath="url(#clip0_purchasers_limit)">
            <path
                d="M13.785 7.54087L15.285 6.01004C15.6345 5.61301 15.8399 5.10984 15.8684 4.58171V1.24837C15.8684 1.02736 15.7806 0.815397 15.6243 0.659117C15.468 0.502836 15.256 0.415039 15.035 0.415039L11.4867 0.420872C10.9593 0.450167 10.4575 0.658263 10.0642 1.01087L1.04086 10.0342C0.884638 10.1905 0.796875 10.4024 0.796875 10.6234C0.796875 10.8443 0.884638 11.0563 1.04086 11.2125L5.07086 15.2425C5.14796 15.3196 5.23957 15.3807 5.34041 15.4222C5.44124 15.4636 5.5493 15.4847 5.65833 15.4842C5.76736 15.4836 5.8752 15.4615 5.97562 15.419C6.07604 15.3765 6.16704 15.3146 6.24336 15.2367L7.11836 14.3434"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11.7017 3.33203C11.7017 3.66355 11.8334 3.98149 12.0678 4.21591C12.3022 4.45034 12.6201 4.58203 12.9517 4.58203C13.2832 4.58203 13.6011 4.45034 13.8355 4.21591C14.07 3.98149 14.2017 3.66355 14.2017 3.33203C14.2017 3.00051 14.07 2.68257 13.8355 2.44815C13.6011 2.21373 13.2832 2.08203 12.9517 2.08203C12.6201 2.08203 12.3022 2.21373 12.0678 2.44815C11.8334 2.68257 11.7017 3.00051 11.7017 3.33203Z"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M9.20166 14.582C9.20166 15.2386 9.33099 15.8888 9.58226 16.4954C9.83354 17.1021 10.2018 17.6533 10.6661 18.1176C11.1304 18.5819 11.6816 18.9502 12.2882 19.2014C12.8949 19.4527 13.5451 19.582 14.2017 19.582C14.8583 19.582 15.5084 19.4527 16.1151 19.2014C16.7217 18.9502 17.2729 18.5819 17.7372 18.1176C18.2015 17.6533 18.5698 17.1021 18.8211 16.4954C19.0723 15.8888 19.2017 15.2386 19.2017 14.582C19.2017 13.2559 18.6749 11.9842 17.7372 11.0465C16.7995 10.1088 15.5277 9.58203 14.2017 9.58203C12.8756 9.58203 11.6038 10.1088 10.6661 11.0465C9.72844 11.9842 9.20166 13.2559 9.20166 14.582Z"
                stroke="currentColor"
                strokeLinejoin="round"
            />
            <path
                d="M10.6665 18.1167L17.7373 11.0459"
                stroke="currentColor"
                strokeLinejoin="round"
            />
        </g>
        <defs>
            <clipPath id="clip0_purchasers_limit">
                <rect width="20" height="20" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export default PurchasersLimitIcon;

